import { triviaTeams } from 'api';
import { toast } from 'react-toastify';

import {
  ENGAGEMENT_DATA,
  PLAN_NAME,
  SUBSCRIPTION_DATA,
  GET_ALL_ADMINS,
  USER_DETAILS,
  ADD_GAME_DATA,
  ADD_HOME_SCHEDULE_DATA,
  ADD_CHANNEL_DATA
} from '../types';

// eslint-disable-next-line import/prefer-default-export
export const GetHomePageData =
  (tenantId, userId = null) =>
  async (dispatch) => {
    const data = await triviaTeams.get('/home', { params: { tenantId, userId } });
    if (data.ok) {
      dispatch({ type: PLAN_NAME, payload: data.plan });
      dispatch({ type: SUBSCRIPTION_DATA, payload: data.subscriptionDetails });
      if (data.enagagementData) {
        dispatch({ type: ENGAGEMENT_DATA, payload: data.enagagementData });
      }
      if (data.userDetails) {
        dispatch({ type: USER_DETAILS, payload: data.userDetails });
      }
      if (data.admins) {
        dispatch({ type: GET_ALL_ADMINS, payload: data.admins });
      }
      if (data.gameData) {
        dispatch({ type: ADD_GAME_DATA, payload: data.gameData });
      }
      if (data.scheduleData) {
        dispatch({ type: ADD_HOME_SCHEDULE_DATA, payload: data.scheduleData });
      }
      if (data.channelData) {
        dispatch({ type: ADD_CHANNEL_DATA, payload: data.channelData });
      }
    } else {
      toast.error(data.error || 'Failed to get home page data');
    }
    return data;
  };
